export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7626.7a518db6.jpg";